module.exports = __webpack_public_path__ + "c962c4d420e3637aa392d09061b6c2d5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/WS.svg
// module id = NcPb
// module chunks = 0